import React, { useEffect, useState } from "react";
import { BsFillEyeFill } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { NavLink, useParams } from "react-router-dom";
import TopButton from "../TopButton/TopButton";
import ProjectsCarousel from "./ProjectsCarousel";
import "./ProjectsDetails.css";
import details from "./ProjectsFakeData";

const ProjectsDetails = () => {
  const { projectsid } = useParams();

  const [detail, setDetail] = useState({});

  useEffect(() => {
    let detail = details.find((d) => d.id == projectsid);
    setDetail(detail);
  }, [projectsid]);

  return (
    <div>
      <div className="container w-75">
        <h1 className="text-center mt-5 mb-5 details-title">
          Project _ {detail?.name}
        </h1>
        <h6 className="text-right">
          <NavLink exact to="/projects" className="nav-links" className="menu-name">
            Back To Projects Section
          </NavLink>
        </h6>
        <div className="row mt-2 carousel-area">
          <div className="col-md-5 col-lg-5 col-sm-5">
            <ProjectsCarousel
              home={detail?.img}
              about={detail?.img1}
              manage={detail?.img2}
              add={detail?.img3}
            ></ProjectsCarousel>
          </div>
          <div className="col-md-7 col-lg-7 col-sm-7">
            <p className="project-description mt-3">{detail?.description}</p>
            <div className="project-detailsP">
              <li>Have admin and user different dashboard.</li>
              <li> Admin can delete, add, manage services.</li>
              <li> Admin can Make Admin also</li>
              <li>User can Login via ( Email-password, Google Sign-in) </li>
              <li>
                <strong className="technology">Front-end Technology:</strong>
                React js, Bootstrap,React Router, Firebase Authentication
              </li>
              <li>
                <strong className="technology">Back-end Technology:</strong>
                Node js,Express js, MongoDB
              </li>
            </div>
            <div class="w-100 pt-4">
              <a href={detail?.clientCode} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  class="btn btn-outline-primary mr-5 mt-3 read sm"
                >
                  <FaGithub /> Client Code
                </button>
              </a>
              <a href={detail?.serverCode} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  class="btn btn-outline-primary mr-5 mt-3 read sm"
                >
                  <FaGithub /> Server Code
                </button>
              </a>
              <a href={detail?.liveSite} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  class="btn btn-outline-primary mr-5 mt-3 read sm"
                >
                  <BsFillEyeFill /> Live Site
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <TopButton></TopButton>
    </div>
  );
};

export default ProjectsDetails;
